import { Component } from '@angular/core';
import { AuthService, config, MemberQuery, LocaleService, LocaleModel } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
declare var gtag: any;
import { filter, tap } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'fgb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    public authService: AuthService,
    private translate: TranslateService,
    private memberQuery: MemberQuery,
    private localeService: LocaleService,
    private router: Router
  ) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + config.googleAnalyticsTag;
    document.head.prepend(script);

    const navigationEvent = this.router.events.pipe(filter((e) => e instanceof NavigationEnd));

    navigationEvent.subscribe((e) => {
      let event = e as NavigationEnd;
      gtag('config', config.googleAnalyticsTag, { page_path: event.urlAfterRedirects });
    });

    /** Google maps API */
    const googleMapsScript = document.createElement('script');
    googleMapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + config.googleMapsAPIKey;
    document.head.prepend(googleMapsScript);

    if (authService.isAuthenticated()) {
      firstValueFrom(
        this.localeService.getLocaleByLcid(parseInt(this.memberQuery.getUserContext().lcid)).pipe(
          tap((locale: LocaleModel) => {
            this.translate.use(locale.CultureCode);
          })
        )
      );
    }
  }
}
